<template>
  <div ref="el">
    <div>
      <span class="d-block">
        Comentario de alarma
      </span>
    </div>
  </div>
</template>

<script>
import nodeMixin from "@/mixins/nodeMixin";

export default {
  props: {
    source: {
      type: String,
      default: "commands",
    },
  },
  mixins: [nodeMixin],
  data() {
    return {
      data: {
        key: 1,
      },
    };
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();

    this.$nextTick(() => {
      this.data.required = this.nodeData.data.required;
      this.data.key++;
    });
  },
  methods: {
    onChange(val) {
      this.data.required = val;
      this.updateNodeData({ required: val });
    },
  },
};
</script>

<style></style>
